export default (str, separator = ' ') =>
  str
    ? str
      .split(separator)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
    : ''
